<template>
    <list-view class="stats-material-list-view">
        <template slot="filterContent" v-if="filterable">
            <veui-field v-if="store.isAdmin"
                field="aderId"
                label="广告主：">
                <veui-select
                    :options="store.aderDatasource"
                    v-model="store.filter.aderId"/>
            </veui-field>
            <veui-field field="timeRange" label="时间：">
                <veui-date-picker
                    ui="alt"
                    range
                    v-model="store.filter.timeRange"/>
            </veui-field>
            <veui-button ui="primary" @click="submitSearch">查询</veui-button>
        </template>

        <template slot="batch">
            <div class="second-header" v-if="downloadable">
                <veui-button @click="downloadReport">下载报告</veui-button>
            </div>
        </template>

        <template slot="tableColumns">
            <slot name="tableColumns"/>
        </template>

        <template slot="after">
            <slot name="after"/>
        </template>
    </list-view>
</template>

<script>
import 'vue-awesome/icons/eye';
import ListView from '@baidu/ve-ria/views/ListView';
import createView from '@baidu/ve-ria/views/createView';
import Model from './ReportListModel';
import {DatePicker, Select, Field, Button} from 'veui';

export default createView(ListView, Model, {
    name: 'report-list-view',
    components: {
        'veui-select': Select,
        'veui-field': Field,
        'veui-date-picker': DatePicker,
        'veui-button': Button
    },
    props: {
        downloadable: Boolean,
        filterable: Boolean
    },
    methods: {
        submitSearch() {
            if (this.store.isAdmin) {
                this.store.requestAderList();
            }
            this.store.submitSearch();
        },
        downloadReport() {
            this.download(this.store.getDownloadUrl());
        }
    }
});
</script>

<style lang="less">
@import '~veui-theme-one/lib.less';
.stats-material-list-view {
    .second-header {
        margin-top: 30px;
        button {
            border-color: @veui-brand-color;
            color: @veui-brand-color;
        }
    }

    td .veui-table-cell {
       .ellipsis();
        width: 100%;

        > .veui-button {
            display: block;
            margin-left: 0;
        }

        .pre-wrap {
            white-space: pre-wrap;
            width: 100%;
        }

        .img-container {
            position: relative;
            width: 100px;
            height: 50px;
            background-size: cover;
            background-position: 50%;
            cursor: pointer;
        }

        .online,
        .binded {
            color: @veui-success-color;
        }
        .offline {
            color: @veui-text-color-aux;
        }
        .developing {
            color: @veui-warning-color;
        }
    }
}

.stats-report-dialog {
    .veui-dialog-content {
        width: 940px;
    }
}
</style>
